<template>
    <div :class="badgeClass">
        <div class="badge__title">{{ title }}</div>
        <button v-if="secondaryIcon" class="badge__icon" @click="emitEvent({ name: 'badge-click-secondary', payload: value })">
            <common-icon
                :name="secondaryIcon"
                :size="iconSize"
                @click="emitEvent({ name: secondaryIcon, payload: value })"
            ></common-icon>
        </button>
        <button v-if="icon" class="badge__icon" @click="emitEvent({ name: 'badge-click', payload: value })">
            <common-icon :name="icon" :size="iconSize" @click="emitEvent({ name: icon, payload: value })"></common-icon>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            title: { type: String, required: true },
            value: { type: [String, Number, Object], default: undefined },
            icon: { type: String, default: undefined },
            secondaryIcon: { type: String, default: undefined },
            type: { type: String, default: 'primary' },
        },

        computed: {
            iconSize() {
                if (this.icon === 'close') {
                    return 'tiny'
                }
                return 'small'
            },

            badgeClass() {
                return {
                    badge: true,
                    [`badge__type-${this.type}`]: true,
                }
            },
        },
    }
</script>
